import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

function renderPriceMetaSummaryContent(summary) {
  if (summary == null)
    return <div className="text-muted small">No summary in price_meta.</div>;

  return (
    <pre className="small mb-0 border rounded p-2 bg-light">
      {JSON.stringify(summary, null, 4)}
    </pre>
  );
}

function renderPriceMetaFullContent(priceMeta) {
  const entries = Object.entries(priceMeta).filter(([k]) => k !== "summary");

  if (entries.length === 0)
    return <div className="text-muted small">No additional fields.</div>;

  return entries.map(([key, value]) => (
    <div key={key} className="mb-3">
      <div className="fw-semibold small text-muted text-uppercase">{key}</div>
      <pre className="small mb-0 border rounded p-2 bg-light">
        {JSON.stringify(value, null, 2)}
      </pre>
    </div>
  ));
}

export default function PriceMetaComponent({
  isOpen,
  toggle,
  priceMeta,
  productName,
}) {
  const [activeTab, setActiveTab] = useState("summary");

  useEffect(() => {
    if (isOpen) setActiveTab("summary");
  }, [isOpen]);

  if (!priceMeta || typeof priceMeta !== "object") return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        <h6 className="m-0">{productName}</h6>
      </ModalHeader>
      <ModalBody>
        <Nav tabs className="mb-3">
          <NavItem>
            <NavLink
              href="#"
              className={activeTab === "summary" ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab("summary");
              }}
            >
              Summary
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="#"
              className={activeTab === "full" ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab("full");
              }}
            >
              Full
            </NavLink>
          </NavItem>
        </Nav>
        {activeTab === "summary" ? (
          <div>{renderPriceMetaSummaryContent(priceMeta.summary)}</div>
        ) : (
          <div>{renderPriceMetaFullContent(priceMeta)}</div>
        )}
      </ModalBody>
    </Modal>
  );
}
